module.exports = __webpack_public_path__ + "img/1498088792.66732e52.jpg";